<template>
  <div id="Nav" :class="navType">
    <div class="back-icon"  v-show="!historyBack">
      <a :href="schemeUrl+'://'">
        <img src="../../assets/icon/image_nav_back_arrow@3x.png" class="back-img">
      </a>
    </div>
    <div class="history-back" v-show="historyBack" @click="goBack">
      <img src="../../assets/icon/image_nav_back_arrow@3x.png" class="back-img">
    </div>
    <div class="title">
      <img :src="userImg" class="user-img">
      <h1>{{this.titleName}}</h1>
    </div>
    <div class="userCoins" v-show="coinShow">
      <img src="../../assets/icon/image_gx_coins@3x.png" alt="">
      <span>{{userCoins}}</span>
    </div>
    <div class="collect" v-show="collectShow" @click="addHome">
      <img src="../../assets/icon/image_nav_collect@3x.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  props:{
    titleName:String,
    navType:String,
    userCoins:String,
    schemeUrl:String,
    userImg:String,
    collectShow:Boolean,
    coinShow:Boolean
  },
  data () {
    return {

    }
  },
  computed:{
    getzType(){
       if(this.navType=='getZ'){
         return true
       }
    },
    getxType(){
       if(this.navType=='getX'){
         return true
       }
    },
    // coinShow(){
    //   return this.$store.state.coinShow
    // },
    historyBack(){
      return this.$store.state.historyBackShow
    }
  },
  methods:{
    goBack(){
      this.$router.go(-1);
      this.$store.commit("updateAllPostCate",{
        "allPostCate":"All"
      })
    },
    addHome(){
      this.$store.commit("updateAddHomeShow",{
        "addHome":true
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
#Nav.getX{
  background-color: #FFF;
  border-bottom: 1px solid rgb(215,215,215);
  .title{
    h1{
      font-size: 16px;
      color: rgb(33,33,33);
      font-weight: bold;
    }
  }
}

  #Nav{
    .userCoins{
      position: absolute;
      right: 15px;
      top: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      img{
        display: block;
        width: 18px;
        height: 18px;
        margin-right: 4px;
      }
      span{
        display: block;
        font-size: 14px;
        color: #FFF;
      }
    }
    .collect{
      position: absolute;
      right: 0px;
      top: 0px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 48px;
      height: 40px;
      img{
        display: block;
        width: 20px;
        height: 20px;
        margin-right: 4px;
      }
    }
    width: 100%;
    height: 40px;
    background: linear-gradient(to right, #1E2022 , #414449);
    position: fixed;
    top:0;
    left: 0;
    display: flex;
    order: 1;
    z-index: 100;
    .history-back{
      position: absolute;
      left: 2px;
      top: 0;
      height: 40px;
      width: 44px;
      justify-content: center;
      align-items: center;
      display: flex;
      img{
        display: block;
        width: 22px;
        height:auto;
      }
      .black-back{
        width: 22px;
        height: auto;
      }
    }
    .back-icon{
      position: absolute;
      left: 12px;
      top: 0;
      a{
        height: 40px;

        justify-content: center;
        align-items: center;
        display: flex;
        .back-img{
          display: block;
          width: 22px;
          height: auto;
          margin-right: 6px;
        }
        .user-img{
          display: block;
          width: 28px;
          height: 28px;
          border-radius: 50%;
        }
      }
    }
    .title{
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      h1{
        font-size: 16px;
        color: #FFF;
        text-align: center;
        margin-left: 8px;
        line-height: 40px;
        font-weight: bold;
      }
      .user-img{
        display: block;
        width: 24px;
        height: 24px;
        border-radius: 50%;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// TopBar.vue?3f8a8f15